import React from 'react'
import { LetterMarkProps } from './LetterMark.types'
import styles from './LetterMark.module.scss'
import cl from 'classnames'
import { Text1 } from '../Text1'

const LetterMarkComponent = (props: LetterMarkProps) => {
  const {
    className,
    style,
    letter,
    noBoxShadow
  } = props

  return (
    <Text1
      className={cl(styles.markLetter, {
        [styles.boxShadow]: !noBoxShadow
      }, className)}
      style={style}
    >
      {letter}
    </Text1>
  )
}

const LetterMark = LetterMarkComponent
export { LetterMark }
